import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormGroup, UntypedFormControl, Validators} from "@angular/forms";
import {Colore, ColoreFactory} from "../../../models/Colore";
import {ProdottoVarianteFactory} from "../../../models/ProdottoVariante";
import {DialogService} from "../dialog/dialog.service";
import {TabTaglieComponent} from "../tab-taglie/tab-taglie.component";
import {TabImmaginiComponent} from "../tab-immagini/tab-immagini.component";

@Component({
   selector: 'app-template-variants',
   templateUrl: './template-variants.component.html',
   styleUrls: ['./template-variants.component.scss']
})
export class TemplateVariantsComponent implements OnInit, AfterViewInit {
   @ViewChild('tabTaglieComponent') tabTaglieComponent!:TabTaglieComponent;
   @ViewChild('tabImmaginiComponent') tabImmaginiComponent!: TabImmaginiComponent;

   @Input() prodottoId
   @Input() pVarianteId
   @Input() productVariant
   @Input() colorId
   @Input() vendorSlug

   public colori:Colore[] = [];
   public varianteFrm: FormGroup = new FormGroup<any>({});

   constructor(private coloreFctr:ColoreFactory,
               private productVariantFctr: ProdottoVarianteFactory,
               private dialogSrv: DialogService
   ) {
      this.initVarianteForm()
   }

   ngOnInit(): void {
      this.fetchColori()
   }

   ngAfterViewInit(): void {
      this.varianteFrm.get('colore')?.patchValue(this.colorId)
      this.colorId = this.productVariant.data.colore?.toString()
   }

   onTabChange(event: any) {
      if (event.index === 1) {
         setTimeout(() => {
            this.tabImmaginiComponent?.refreshGridLayout();
         }, 50);
      }
   }

   fetchColori(){
      this.coloreFctr.getColori(this.vendorSlug).then((colori) => {
         this.colori = colori
         console.log(this.colori)
      }).catch(err => {
         console.error(err)
      })
   }

   initVarianteForm(){
      this.varianteFrm =  new FormGroup({
         codice: new UntypedFormControl('', Validators.required),
         desc_colore: new UntypedFormControl(''),
         colore: new UntypedFormControl('', Validators.required),
         prodotto: new UntypedFormControl(this.prodottoId)
      });
   }

   clickEditVariante() {
      this.productVariantFctr.putProdottoVariante(this.prodottoId, this.productVariant.data.id, this.varianteFrm.value, this.vendorSlug).then(res => {
         this.dialogSrv.showSuccess({title:"Modifica variante", msg:"Variante modificata"})
         // this.popupVisible = false
         this.tabTaglieComponent.gridInstances.instance.refresh()
      }).catch(err => {
         console.error(err)
         this.dialogSrv.showError({title:"Modifica prodotto", err:err})
      })
   }
}
